<template>
  <a-table
    :dataSource="dataSource"
    :columns="columns"
    class="mb40"
    :pagination="pagination"
    bordered
  >
    <template v-slot:bodyCell="{ column, record }">
      <!-- record, index -->
      <template v-if="column.dataIndex == 'time'"
        >{{ record.activityEffectStartTime }} -
        {{ record.activityEffectEndTime }}</template
      >
      <template v-if="column.dataIndex === 'status'">
        <a-badge :text="statusOps[record.status]" />
      </template>
      <!-- <template v-if="column.dataIndex === 'entranceStatus'">
        <a-switch :checked="text" @change="e => handleOpenEntry(e, record)" />
      </template> -->
      <template v-if="column.dataIndex == 'operate'">
        <a-button type="link" @click="addActive(2, record)">查看</a-button>
        <a-button type="link" @click="addActive(1, record)">编辑</a-button>
        <a-button type="link" size="small" @click="generateLink(record)">
          生成链接
        </a-button>
      </template>
    </template>
  </a-table>
</template>

<script>
import { inject, reactive, toRefs } from 'vue'
export default {
  setup() {
    const state = reactive({
      statusOps: {
        0: '未知',
        1: '未开始',
        2: '进行中',
        3: '已结束'
      }
    })
    return {
      ...toRefs(state),
      ...toRefs(inject('initState'))
    }
  }
}
</script>

<style lang="scss" scoped></style>
